import { useCallback } from "react";
import { isMobile } from "react-device-detect";
import { useFirebaseService } from "../../utils/useFirebase";
import { DeviceIDPatch } from "../../services/scim/profile/DeviceIDPatch";
import { toast } from "react-toastify";

interface UseDeviceRegistrationReturn {
  updateDeviceIdWeb: (
    webId: string | undefined,
    userId: string
  ) => Promise<void>;
}

export const useDeviceRegistration = (): UseDeviceRegistrationReturn => {
  const updateDeviceIdWeb = useCallback(
    async (webId: string | undefined, userId: string) => {
      try {
        const device = await useFirebaseService.requestNotificationPermission();

        if (!webId && device) {
          await DeviceIDPatch({
            idUser: userId,
            operation: "add",
            pathName:
              "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User:deviceIDWeb",
            valueField: device,
          });
        }

        if (webId !== undefined && webId !== device && !isMobile) {
          await DeviceIDPatch({
            idUser: userId,
            operation: "replace",
            pathName:
              "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User:deviceIDWeb",
            valueField: device,
          });
        }
      } catch (error) {
        toast.error("Erro ao registrar dispositivo");
        console.error("Erro ao registrar dispositivo:", error);
      }
    },
    []
  );

  return { updateDeviceIdWeb };
};
